import React from 'react';
import styled from 'styled-components';
import { space, layout } from 'styled-system';

const Wrapper = styled('svg').withConfig({
  shouldForwardProp: (prop) => !['width'].includes(prop),
})`
  width: 16px;

  ${layout}
  ${space}
`;

const arrowLeft = ({ style }) => (
  <Wrapper {...style} viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.71 4.81918L8.11996 9.40918L12.71 13.9992L11.29 15.4092L5.28996 9.40918L11.29 3.40918L12.71 4.81918Z"
      fill="currentColor"
    />
  </Wrapper>
);

export default arrowLeft;
